exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.export-stage-checkbox-group {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n}\n.export-stage-checkbox-inline {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 10px;\n    margin-bottom: 5px;\n}\n.export-stage-checkbox-inline input[type=\"checkbox\"] {\n    vertical-align: middle;\n    margin-right: 5px;\n}\n", ""]);

// exports
